export default {
  cyan: '#3ca19f',
  red: '#de3a3a'
};

